module.exports = __webpack_public_path__ + "img/gear-F_74x74.fdab3d06.png";